export default __webpack_public_path__ + "static/media/plate.90180f9e.png";